import React, { useEffect, useState } from "react";
import hero1 from "../images/hero_1.jpg";
import axios from "../axios/axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import UserCard from "../component/UserCard";
import { useParams } from "react-router-dom";

function UserApplied() {
  const [users, setUsers] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const { userInfo } = useSelector((state) => state.signIn);
  console.log(users);

  const getUsers = async () => {
    try {
      const { data } = await axios.get(
        `/api/company/jobs/${userInfo.user._id}/users`
      );
      setUsers(data);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const handleSortChange = (e) => {
    setSortBy(e.target.value);
  };

  const sortUsers = (usersList) => {
    if (sortBy === "newest") {
      return usersList.sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
      );
    } else if (sortBy === "oldest") {
      return usersList.sort(
        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
      );
    } else {
      return usersList;
    }
  };
  const onAccept = () => {
    getUsers();
  };
  return (
    <>
      <section
        class="section-hero overlay inner-page bg-image"
        style={{ backgroundImage: `url(${hero1})` }}
        id="home-section"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-7 mt-5">
              <h3 class="text-white ">Applied Candidates for this Job</h3>
              <Link to="/" style={{ color: "white" }}>
                Home
              </Link>
              <span class="mx-2 slash">/</span>
              <Link to="/company/appliedUsers" style={{ color: "white" }}>
                Company
              </Link>
              <span class="mx-2 slash">/</span>
              <span class="text-white">
                <strong>Applied Users</strong>
              </span>
            </div>
          </div>
        </div>
      </section>
      {users?.length === 0 ? (
        <h1 style={{ textAlign: "center" }}>No applied Users Yet!</h1>
      ) : (
        <section class="site-section" id="next">
          <div class="container">
            <div class="row mb-5 justify-content-center">
              <div class="col-md-7 text-center">
                <h2 class="section-title mb-2">Applied Users</h2>
              </div>
            </div>

            <div class="form-group">
              <label for="sortSelect">Sort by:</label>
              <select
                class="form-control"
                id="sortSelect"
                value={sortBy}
                onChange={handleSortChange}
              >
                <option value="">-- Select --</option>
                <option value="oldest">Oldest to Newest</option>
                <option value="newest">Newest to Oldest</option>
              </select>
            </div>

            <div className="appliedUsers">
              {sortUsers(users)?.map((user, i) => (
                <UserCard
                  key={i}
                  id={user._id}
                  username={user.username}
                  email={user.email}
                  profilePic={user.profilePic}
                  yearsOfExperience={user.yearOfExperience}
                  location={user.location}
                  cv={user.cv}
                  whoami={user.whoami}
                  createdAt={user.createdAt}
                  position={user.position}
                  onAccept={onAccept}
                  status={user.appliedJobs[i].status}
                />
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default UserApplied;
